import { defaultReportsFilterFields } from '@/features/reports/constants/defaultReportsFilterFields.constant';

export const reportFilters = {
  default: defaultReportsFilterFields.textField,
  defaultCheckbox: defaultReportsFilterFields.checkbox,
  created_at_gteq: defaultReportsFilterFields.dateField,
  created_at_lteq: defaultReportsFilterFields.dateField,
  closed_at_gteq: defaultReportsFilterFields.dateField,
  closed_at_lteq: defaultReportsFilterFields.dateField,
  due_at_gteq: defaultReportsFilterFields.dateField,
  due_at_lteq: defaultReportsFilterFields.dateField,
  city_id_eq: defaultReportsFilterFields.citySelectField,
  days_without_usage_gteq: defaultReportsFilterFields.numberField,
  equipment_category_id_eq: defaultReportsFilterFields.equipmentCategorySelectField,
  equipment_status_eq: defaultReportsFilterFields.equipmentStatusSelectField,
  product_id_eq: defaultReportsFilterFields.productSelectField,
  client_branch_id_eq: defaultReportsFilterFields.clientCompanyBranchSelectField,
  client_equipment_id_eq: defaultReportsFilterFields.clientEquipmentSelectField,
  property_kind_eq: defaultReportsFilterFields.equipmentPropertyKindSelectField,
  usage_kind_eq: defaultReportsFilterFields.equipmentUsageKindSelectField,
};
